import { apiRemote } from '../../Services/RemoteService';
import { getPropertyOwnerSchedulingPreferencesPayload } from './utils';

class DoorwayAPI {
  static getDoorwaySettings() {
    return apiRemote
      .get(`admin/doorway`)
      .then((response) => response.json())
      .catch((e) => e);
  }

  static getPropertiesScheduling() {
    return apiRemote
      .get('admin/scheduling')
      .then((response) => response.json())
      .catch((e) => e);
  }

  static updateDoorwaySettings(
    propertyId,
    { preferences, hours, message_templates },
  ) {
    return apiRemote
      .put(`admin/doorway/${propertyId}`, {
        preferences,
        hours,
        message_templates,
      })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to update doorway settings: ${response.status}`);
        }
        return response.json();
      });
  }

  static updatePropertyOwnerSchedulingPreferences(
    propertyId,
    propertyOwnerSchedulingPreferences,
  ) {
    const payload = getPropertyOwnerSchedulingPreferencesPayload(
      propertyOwnerSchedulingPreferences,
    );

    return apiRemote
      .put(`admin/scheduling/${propertyId}`, payload)
      .then((response) => response.json());
  }
}

export default DoorwayAPI;
